import type { TFunction } from 'i18next'
import { createErrorMapRule } from '../utils/create-rule.ts'
import type { TranslationKey } from '../utils/types.ts'

export const invalidStringRule = (t: TFunction<'validation'>) =>
  createErrorMapRule('invalid_string', t, (issue, _, t) => {
    let translationKey: TranslationKey = 'string.invalid'

    if (typeof issue.validation === 'object') {
      if ('includes' in issue.validation) {
        if (typeof issue.validation.position === 'number') {
          translationKey = 'string.missing-character-at-position'
        } else {
          translationKey = 'string.missing-character'
        }
      }

      if ('startsWith' in issue.validation) {
        translationKey = 'string.missing-start'
      }

      if ('endsWith' in issue.validation) {
        translationKey = 'string.missing-end'
      }
    } else if (issue.validation !== 'regex') {
      translationKey = 'string.invalid-pattern'
    }

    return {
      message: t(translationKey, {
        ...issue,
      }),
    }
  })
